export const GOD_EMPLOYEE = 'Support Employee';
export const EMPLOYEE = 'Employee';
export const DEALER_REP = 'Dealer Representative';
export const DEALER_LOC_ADMIN = 'Dealership Location Admin';
export const CLIENT = 'Client';
